import React from 'react'

import {
  Box,
  Space,
  Text,
  GridDisplay,
  Display,
  FlexDirection,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { NumPersonsToBoxDescriptorsItem } from 'routes/BoxPrices/boxPricesModels'
import { signupConfig } from 'routes/Signup/signupConfig'

import { largeGapGridTemplateColumns, smallGapGridTemplateColumns } from './constants'
import { BestValueBadge, AccordionTableCell, TableRowContainer } from './index'

type AccordionTableRowProps = {
  boxPrice: NumPersonsToBoxDescriptorsItem
  isLoading: boolean
  isBestValue: boolean
}

const TableCellContainer = ({
  children,
  isContentCentered,
}: React.PropsWithChildren<{ isContentCentered: boolean }>) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    justifyContent={isContentCentered ? JustifyContent.Center : JustifyContent.FlexStart}
  >
    {children}
  </Box>
)

export const AccordionTableRow = ({ isLoading, boxPrice, isBestValue }: AccordionTableRowProps) => {
  const { pricePlaceholder, wasPricePlaceholder } = signupConfig.boxSizePriceBreakdownStep
  const {
    num_portions: numPortions,
    promo_code_valid: promoCodeValid,
    totalAfterDiscount,
    total,
    price_per_portion: pricePerPortion,
    price_per_portion_discounted: pricePerPortionDiscounted,
  } = boxPrice
  const perBoxColumnText = {
    mainText: promoCodeValid ? `£${totalAfterDiscount}` : `£${total}`,
    subText: promoCodeValid ? `Was £${total}` : '',
  }
  const perPortionColumnText = {
    mainText: promoCodeValid ? `£${pricePerPortionDiscounted}` : `£${pricePerPortion}`,
    subText: promoCodeValid ? `Was £${pricePerPortion}` : '',
  }
  const isDataLoadingOrInvalid = isLoading || !pricePerPortion

  return (
    <TableRowContainer
      display={GridDisplay.Grid}
      gridTemplateColumns={[smallGapGridTemplateColumns, null, largeGapGridTemplateColumns]}
      minHeight="46px"
    >
      <TableCellContainer isContentCentered={!promoCodeValid}>
        <Text size={2}>
          <Space size={1} direction="horizontal" />
          {`${numPortions} recipes`}
        </Text>
        {isBestValue && <BestValueBadge />}
      </TableCellContainer>

      <TableCellContainer isContentCentered={!promoCodeValid}>
        <AccordionTableCell size="large">
          {isDataLoadingOrInvalid ? pricePlaceholder : perBoxColumnText.mainText}
        </AccordionTableCell>
        <AccordionTableCell size="small">
          {isDataLoadingOrInvalid ? wasPricePlaceholder : perBoxColumnText.subText}
        </AccordionTableCell>
      </TableCellContainer>

      <TableCellContainer isContentCentered={!promoCodeValid}>
        <AccordionTableCell size="large">
          {isDataLoadingOrInvalid ? pricePlaceholder : perPortionColumnText.mainText}
        </AccordionTableCell>
        <AccordionTableCell size="small">
          {isDataLoadingOrInvalid ? wasPricePlaceholder : perPortionColumnText.subText}
        </AccordionTableCell>
      </TableCellContainer>
    </TableRowContainer>
  )
}
